import { FilterService } from '../Service/FilterService';

const useGetFilteredResults = <T>(dataSet: T[], keyword: string, minLength = 3): T[] => {
    if (keyword.length >= minLength) {
        const filterService = new FilterService();
        return filterService.filter(dataSet, keyword, true, ['findataCode', 'iconUrl']);
    }

    return [];
};

export default useGetFilteredResults;
